import { DateRangePicker } from './date-range-picker/DateRangePicker'
import { DatePickerProps } from './DatePicker.types'
import { SingleDatePicker } from './single-date-picker/SingleDatePicker'

export function DatePicker(props: DatePickerProps) {
  const { mode } = props

  if (mode === 'range') {
    return <DateRangePicker {...props} />
  }

  return <SingleDatePicker {...props} />
}
